import { Link } from 'react-router';

/**
 * Layer-1 themed link component.
 * Wraps React Router Link with consistent text styling.
 * Use this instead of raw <Link> for all user-facing anchor elements.
 */
type ThemedLinkProps = React.ComponentPropsWithoutRef<typeof Link>;

export function ThemedLink({ className = '', ...props }: ThemedLinkProps) {
  return (
    <Link
      {...props}
      className={`text-[var(--foreground)] hover:opacity-75 transition-opacity duration-200 ${className}`.trim()}
    />
  );
}
